import './Login.css';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import api from '../../services/api';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import imagem from '../../assets/jap.png';
import useAlerta from '../../common/components/useAlerta';
import AppSnackbar from '../../common/components/AppSnackbar';

function Login() {
  const { register, handleSubmit, reset } = useForm();
  const { alerta, mostrarAlerta, fecharAlerta } = useAlerta();
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      navigate('/');
    }
  }, [navigate]);

  const onSubmit = async (data) => {
    try {
      const response = await api.post('/auth/login', data);
      mostrarAlerta(`Bem-vindo ${response.data.nome}!`, 'success');
      const token = response.data.token;
      const id = response.data.id;
      const permissoes = response.data.permissoes;
      const foto = response.data.foto;
      localStorage.setItem('token', token);
      localStorage.setItem('id', id);
      localStorage.setItem('permissoes', JSON.stringify(permissoes));
      localStorage.setItem('foto', foto);
      setTimeout(() => {
        window.location.href = '/feed';
      }, 3000);
    } catch (error) {
      const mensagemErro = error.response?.data?.message || 'Email ou senha não encontrado';
      mostrarAlerta(mensagemErro, 'error');
      reset();
    }
    setTimeout(fecharAlerta, 1500);
  };

  return (
    <Box className="login-background">
      <Box className="login-overlay" />

      <Paper
        elevation={6}
        sx={{
          position: 'relative',
          zIndex: 1,
          width: '100%',
          maxWidth: 400,
          mx: 2,
          p: 4,
          borderRadius: 3,
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
          <img src={imagem} alt="Logo Jap" style={{ height: 48 }} />
        </Box>

        <Typography variant="h6" align="center" sx={{ mb: 3, color: 'text.secondary' }}>
          Acesse o sistema
        </Typography>

        <Box component="form" onSubmit={handleSubmit(onSubmit)} noValidate>
          <TextField
            {...register('email')}
            id="email"
            label="E-mail"
            type="text"
            placeholder="Digite seu e-mail"
            required
            fullWidth
            margin="normal"
          />
          <TextField
            {...register('password')}
            id="password"
            label="Senha"
            type="password"
            placeholder="Digite sua senha"
            required
            fullWidth
            margin="normal"
          />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            size="large"
            sx={{ mt: 3, py: 1.2 }}
          >
            Entrar
          </Button>
        </Box>
      </Paper>

      <AppSnackbar alerta={alerta} onClose={fecharAlerta} />
    </Box>
  );
}

export default Login;
